// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"99055174","703":"ded86de1","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};